import serviceAwardsSdk from '../../../services/service-awards-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    mostRecentProcedure: null,
    lastFewProcedures: [],
    mostRecentEvent: null,
    lastFewEvents: [],
    errorMessage: ''
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'program/setState';

/*******************************************************************************
 * Reducer
 */
export default function healthReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}

function loadMostRecentProcedure() {
    return async( dispatch ) => {
        dispatch( setState( { loading: true, errorMessage: '' } ) );
        try {
            const res = await serviceAwardsSdk.getMostRecentProcedure();
            dispatch( setState( { loading: false, mostRecentProcedure: res } ) );
        } catch ( error ) {
            dispatch( setState( { loading: false, mostRecentProcedure: null, errorMessage: error.message } ) );
        }
    };
}
function loadMostRecentEvent() {
    return async( dispatch ) => {
        dispatch( setState( { loading: true, errorMessage: '' } ) );
        try {
            const res = await serviceAwardsSdk.getMostRecentEvent();
            dispatch( setState( { loading: false, mostRecentEvent: res } ) );
        } catch ( error ) {
            dispatch( setState( { loading: false, mostRecentEvent: null, errorMessage: error.message } ) );
        }
    };
}
function loadLastFewProcedures() {
    return async( dispatch ) => {
        dispatch( setState( { loading: true, errorMessage: '' } ) );
        try {
            const res = await serviceAwardsSdk.getLastFewProcedures();
            dispatch( setState( { loading: false, lastFewProcedures: res.procedures } ) );
        } catch ( error ) {
            dispatch( setState( { loading: false, lastFewProcedures: [], errorMessage: error.message } ) );
        }
    };
}
function loadLastFewEvents() {
    return async( dispatch ) => {
        dispatch( setState( { loading: true, errorMessage: '' } ) );
        try {
            const res = await serviceAwardsSdk.getLastFewEvents();
            dispatch( setState( { loading: false, lastFewEvents: res.events } ) );
        } catch ( error ) {
            dispatch( setState( { loading: false, lastFewEvents: [], errorMessage: error.message } ) );
        }
    };
}

export const actions = {
    loadMostRecentProcedure,
    loadMostRecentEvent,
    loadLastFewProcedures,
    loadLastFewEvents
};
